import { RecipeTagsSection } from "./RecipeTagsSection";
import { RecipeIngredientsSection } from "./RecipeIngredientsSection";
import { RecipeInstructionsSection } from "./RecipeInstructionsSection";
import { RecipeInfoSection } from "./RecipeInfoSection";
import React from "react";

export function RecipeInfo({ recipe, scale, setScale, system, setSystem, convertToMass, setConvertToMass, ...props }) {
	return (
		<React.Fragment>
			{(!recipe.tags || recipe.tags.length === 0) ? "" : (
				<RecipeTagsSection tags={recipe.tags} />
			)}
			{!recipe.ingredientsList ? (
				recipe.ingredients ? (
					<RecipeInfoSection
						title="Ingredients"
						body={recipe.ingredients} />
				) : ""
			) : (
				<RecipeIngredientsSection
					title="Ingredients"
					scale={scale}
					setScale={setScale}
					system={system}
					setSystem={setSystem}
					convertToMass={convertToMass}
					setConvertToMass={setConvertToMass}
					imageUrls={props.imageUrls}
					ingredientsList={recipe.ingredientsList} />
			)}
			{!recipe.instructions ? "" : (
				<RecipeInstructionsSection
					title="Instructions"
					instructions={recipe.instructions} />
			)}
			{!recipe.notes ? "" : (
				<RecipeInfoSection
					title="Notes"
					body={recipe.notes} />
			)}
		</React.Fragment>
	);
}
